// extracted by mini-css-extract-plugin
export default {"PageLayout":"paginated-archive-view-module__PageLayout--HE9_W","Box":"paginated-archive-view-module__Box--hk1fj"};